import React from 'react';
import { Link } from 'react-router-dom';
import PayrollCalendar from './PayrollCalendar';

const MaltaLandingHero = ({
  headline,
  subtext,
  primaryCtaText = "Watch 15-min Demo",
  primaryCtaLink = "#demo",
  secondaryCtaText = "Secure €450 Migration",
  secondaryCtaLink = "#",
  trustBadges = [
    "Migration + training €450",
    "First live run billed in January",
    "No long-term contracts"
  ],
  urgencyMessage = ""
}) => {
  const handlePrimaryClick = (e) => {
    if (primaryCtaLink.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(primaryCtaLink);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleSecondaryClick = (e) => {
    // Track CTA click
    if (window.gtag) {
      window.gtag('event', 'click_secure_migration', {
        'event_category': 'conversion',
        'event_label': 'hero'
      });
    }
  };

  return (
    <main className="pt-8 sm:pt-16 md:pt-20 lg:pb-24 pb-8 sm:pb-16 md:pb-20 lg:pb-24">
      <div className="mx-auto max-w-screen-xl">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
            <div>
              {urgencyMessage && (
                <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-red-100 text-red-800 mb-4">
                  ⚠️ {urgencyMessage}
                </div>
              )}
              <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                {headline}
              </h1>
              <p className="mt-3 text-base text-advisor-100 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                {subtext}
              </p>
              
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link
                  to={primaryCtaLink}
                  onClick={handlePrimaryClick}
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-advisor-900 bg-white hover:text-advisor-700 hover:bg-advisor-50 transition duration-150 ease-in-out sm:w-auto"
                >
                  {primaryCtaText}
                </Link>
                <a
                  href={secondaryCtaLink}
                  onClick={handleSecondaryClick}
                  className="inline-flex items-center justify-center px-5 py-3 border border-white text-base leading-6 font-medium rounded-md text-white hover:bg-white hover:text-advisor-900 transition duration-150 ease-in-out sm:w-auto"
                >
                  {secondaryCtaText}
                </a>
              </div>

              {/* Trust Badges */}
              <div className="mt-8 flex flex-wrap gap-2 justify-center lg:justify-start">
                {trustBadges.map((badge, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-advisor-100 text-advisor-800"
                  >
                    {badge}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
            <PayrollCalendar />
          </div>
        </div>
      </div>
    </main>
  );
};

export default MaltaLandingHero;
